import React from 'react';
import DOMPurify from 'dompurify';
import ToolTip from '@atlaskit/tooltip';
import type { ExtraFieldDate } from '../../../../../../model/extra-fields/types';
import { Container } from '../styled';
import { isDefault, parseContent } from '../utils';

type Props = { field: ExtraFieldDate };

export function DateField({ field }: Props) {
	let content = parseContent(field.html);

	if (isDefault(content)) {
		content = parseContent(field.text);
	}

	return (
		<ToolTip content={field.label}>
			<Container
				as="time"
				// @ts-expect-error Property 'dateTime' does not exist on type 'IntrinsicAttributes & { isDefault: boolean; } & ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps & { ...; }'.
				dateTime={field.text}
				aria-hidden={isDefault(content) ? 'true' : 'false'}
				aria-label={field.label}
				isDefault={isDefault(content)}
				dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
			/>
		</ToolTip>
	);
}
